var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocateMe = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-locate-3842695",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.707,
    height: 29.746,
    viewBox: "0 0 32.707 29.746",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M257.05,203.032a6.413,6.413,0,0,0-11.843.9,6.336,6.336,0,0,0,.344,4.889l4.613,9.055a1.218,1.218,0,0,0,1.136.689,1.279,1.279,0,0,0,1.136-.689c.034-.069,3.787-7.368,4.648-9.055a6.454,6.454,0,0,0-.035-5.784Zm-5.749,6.025a3.03,3.03,0,1,1,3.03-3.03A3.034,3.034,0,0,1,251.3,209.057Z",
    transform: "translate(-234.982 -189.57)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M115.4,53.158h-1.377a13.731,13.731,0,0,0-12.36-12.36V39.386a1.308,1.308,0,0,0-2.617,0V40.8a13.759,13.759,0,0,0-12.36,12.325H85.309A1.308,1.308,0,0,0,84,54.431a1.279,1.279,0,0,0,1.308,1.274h1.412A13.8,13.8,0,0,0,97.153,67.79a2.5,2.5,0,0,1-.172-.31L95.4,64.416a11.218,11.218,0,0,1-6.059-8.71h1.274a1.308,1.308,0,0,0,0-2.617H89.337a11.115,11.115,0,0,1,9.743-9.674v1.274a1.308,1.308,0,0,0,2.617,0V43.415a11.186,11.186,0,0,1,9.743,9.743H110.1a1.308,1.308,0,0,0,0,2.617h1.343a11.3,11.3,0,0,1-6.266,8.745c-.826,1.652-1.515,2.961-1.515,2.961-.069.1-.138.241-.207.344A13.711,13.711,0,0,0,114.022,55.74H115.4a1.291,1.291,0,1,0,0-2.582Z",
    transform: "translate(-84.001 -38.078)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocateMe);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "dab116e74a339e8934c71460070d3368.svg";